import {
  AUTH_SET_SESSION,
  AUTH_LOGOUT,
  AUTH_UPDATE_USER,
  AUTH_SET_ONBOARDING,
} from "./actionTypes";

export const initialAuthState = {
  accessToken: null,
  user: null,
  role: null,
  hasCompletedOnBoarding: false,
};

const auth = (state = initialAuthState, action) => {
  switch (action.type) {
    case AUTH_SET_SESSION: {
      const { accessToken, user } = action.payload;
      return {
        accessToken,
        user,
        role: user?.role ?? null,
        hasCompletedOnBoarding: Boolean(user?.hasCompletedOnBoarding),
      };
    }
    case AUTH_UPDATE_USER: {
      const user = action.payload;
      return {
        ...state,
        user,
        role: user?.role ?? state.role,
        hasCompletedOnBoarding:
          user?.hasCompletedOnBoarding !== undefined
            ? Boolean(user.hasCompletedOnBoarding)
            : state.hasCompletedOnBoarding,
      };
    }
    case AUTH_SET_ONBOARDING:
      return {
        ...state,
        hasCompletedOnBoarding: Boolean(action.payload),
      };
    case AUTH_LOGOUT:
      return { ...initialAuthState };
    default:
      return state;
  }
};

export default auth;
